





































import { defineComponent, computed } from '@vue/composition-api';

export default defineComponent({
  components: {
   
  },
  props: {
    state: {
      type: String,
      required: true,
      validator: (value: string) => {
        return ['close', 'back', 'open'].indexOf(value) !== -1;
      }
    },
    showText: {
      type: Boolean,
      default: false
    }
  },
  emits: {
    'click': (/*buttonState: string*/) => true
  },

  setup(props) {

    const buttonText = computed(() => {
      switch(props.state) {
        case 'open': return 'Menu';
        case 'back': return 'Back';
        default: return 'Close';
      }
    });
    return {
      buttonText
    };
  }

});
